export class GameSettingsManager {
  private gameIdentifier: string;

  constructor(gameIdentifier: string) {
    this.gameIdentifier = gameIdentifier;
  }

  public getSettingValue(name, defaultValue) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${this.gameIdentifier}-${name}=`);

    if (parts.length === 2) {
      const part = parts.pop();

      if (typeof part !== 'undefined') {
        return part.split(';').shift();
      }
      else {
        return defaultValue;
      }
    }
    else {
      return defaultValue;
    }
  }

  public setSettingValue(name: string, value: string) {
    const date = new Date();
    const numYears = 5;
    date.setTime(date.getTime() + (numYears * 365 * 24 * 60 * 60 * 1000));
    document.cookie = `${this.gameIdentifier}-${name}=${value};expires=${date.toUTCString()};path=/`;
  }
}

